module.exports = new Promise(resolve => {
            const script = document.createElement('script');
            script.src = window.location.origin + '/mfe/patient360/remoteEntry.js';
            script.onload = () => { resolve(window['patient360']); };
            script.onerror = () => { resolve({ get: () => Promise.resolve(() => () => 'Module patient360 unavailable'), init: () => {} }); };
            document.head.appendChild(script);
        });